import { post, queryKeys, SignUpUrl } from '@mobi/account/Utils'
import { ApplicationSubmitRequest, ApplicationSubmitResponse } from '@mobi/api-types/index'

import { useMutation } from '@tanstack/react-query'

export const useApplicationSubmit = (applicationNumber: number) => {
  const { mutate: applicationSubmit, status: applicationSubmitStatus } = useMutation<
    ApplicationSubmitResponse,
    Error,
    ApplicationSubmitRequest
  >({
    mutationFn: (req): Promise<ApplicationSubmitResponse> =>
      post(SignUpUrl.applicationSubmit(applicationNumber.toString()), req),
    mutationKey: [queryKeys.signupApplicationSubmit, applicationNumber],
  })
  return { applicationSubmit, applicationSubmitStatus }
}
